import styled from 'vue-styled-components';
import css from 'vue-styled-components';

export const CardOfCar = styled.section`
  --bg-color-CardOfCar: #d0d0d2;
  background-color: var(--bg-color-CardOfCar);
  border-radius: 1rem 1rem 1rem 0;
  padding: 1.25rem 1rem 3rem;
  margin: 0 0 1.857rem;
  overflow: hidden;
  position: relative;
  ${({ selected, theme }) =>
    selected &&
    css`
      border: 3px solid ${theme.colors.main};
    `}
  ${({ selectable }) =>
    selectable &&
    css`
      cursor: pointer;
    `}
  img {
    width: 100%;
  }
`

export const CardSelect = styled.div`
  background-color: rgba(255, 255, 255, 0.5);
  display: grid;
  place-items: center;
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
  z-index: 100;
`

export const TopBlurCardOfCar = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  border-radius: 1.6rem ;
  background: linear-gradient(180deg, #EFBFBF 5%, rgba(196, 196, 196, 0) 15%);
`

export const ContainerTitlesCard = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 100;
  h1, h2 {
    color: #fff;
    font-weight: 200;
    font-size: 1.175rem;
  }
`

export const CarSearch = styled.button`
  background-color: #fff;
  border-radius: 1rem 0 0 0;
  cursor: pointer;
  padding: 1rem;
`


export const ActionsButtons = styled.button`
  cursor: pointer;
  display: grid;
  place-items: center;
  border-radius: 0.3rem;
  padding: 0.5rem;
  background-color: #ffff;
  margin-bottom: 0.5rem;
`

export const FetchPartsContainer = styled.div`
  width: 100%;
  display: inline-block;
  text-align: right;
  position: absolute;
  bottom: 0;
  left: 0;
`
export const PartsTitle = styled.span`
  font-weight: bolder;
  font-size: 1rem;
  margin: 0 0.5rem 0;
  text-decoration: none;
`